import React, { JSX } from 'react';
import { observer } from 'mobx-react';
import PaxRoomSelectionController from './PaxRoomSelectionController';
import { range } from 'lodash-es';
import { ReactSelectOption } from '@ibe/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const NativeAgeSelect = observer(
  ({
    roomIndex,
    childIndex,
    childAgePlaceholder,
    maxChildAge,
    state,
    onChange
  }: {
    roomIndex: number;
    childIndex: number;
    childAgePlaceholder?: string;
    maxChildAge?: number;
    state: PaxRoomSelectionController;
    onChange?: (roomIndex: number, childIndex: number, newValue: ReactSelectOption) => void;
  }): JSX.Element => {
    const finalMaxChildAge = maxChildAge ? maxChildAge + 1 : state.defaultChildAgeLimit;

    const selectElemId = 'childAgePicker' + (childIndex + 1);
    const selectedAge =
      state.rooms[roomIndex].childrenAges.length > childIndex &&
      !Number.isNaN(state.rooms[roomIndex].childrenAges[childIndex])
        ? state.rooms[roomIndex].childrenAges[childIndex]
        : undefined;

    return (
      <div className="child-age-picker-native-container">
        <select
          id={selectElemId}
          className="child-age-picker-native"
          defaultValue={selectedAge}
          onChange={({ target: { value } }) => {
            const val = state.getChildAgeOption(Number(value));
            onChange
              ? onChange(roomIndex, childIndex, val)
              : state.setChildAgeForRoom(roomIndex, childIndex, val);
          }}
        >
          {childAgePlaceholder && selectedAge === undefined && (
            <option>{childAgePlaceholder}</option>
          )}
          {range(0, finalMaxChildAge).map(val => {
            return (
              <option key={val} value={val}>
                {val}
              </option>
            );
          })}
        </select>
        <FontAwesomeIcon
          icon={faChevronDown}
          className="child-age-picker-native-icon px-2"
          aria-hidden={true}
        />
      </div>
    );
  }
);

export default NativeAgeSelect;
